import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Development, Property, RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  data: Development | Property
  from: string
  development?: Development
  property?: Property
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Contact_6 = ({
  data,
  from,
  title,
  underlineMode,
  is_wide,
  button,
  development,
  property,
  titleSecondary,
  global_data,
  image,
  image_center,
  alignCenter,
  titleElement,
  titleColor,
  titleHexa,
  customBorderRadius,
}: CombinedProps) => {
  const FormComponent = require(`@components/form/8`)?.default

  return (
    <div className="div contact-texture-container py-config">
      <Container
        className="contact-texture"
        fluid
      >
        {image_center && (
          <img
            src={image_center}
            alt=""
            className="position-absolute background-texture"
          />
        )}
        <Row className={'contacto-main p-y-config ' + (is_wide ? 'is_wide_component' : '')}>
          <Col
            lg={6}
            className="text-column d-flex justify-content-center mx-auto order-lg-1 order-2"
          >
            <img
              src={image}
              alt=""
              className="left-image"
            />
          </Col>
          <Col
            lg={6}
            className={`form-column order-lg-2 order-1 ${
              is_wide ? 'mt-lg-5 pt-lg-3 mt-4 mx-auto' : ''
            }`}
          >
            <ElementHTML
              className={`mb-4 pe-lg-5 section-name ${titleSecondary ? 'text-secondary' : ''} ${
                alignCenter ? ' text-center ' : ''
              } ${titleColor}`}
              children={title || 'Contacto'}
              elementType={titleElement || 'h2'}
              style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
            />
            <FormComponent
              data={data}
              underlineMode={underlineMode}
              from={from}
              button={button}
              development={development}
              property={property}
              global_data={global_data}
              customBorderRadius={customBorderRadius} // captcha={form?.captcha}
            />
            <div id="alert-message"></div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default Contact_6
